import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCreditCard,
  FaMoneyBillWave,
  FaListAlt,
  FaSyncAlt,
  FaExclamationTriangle,
  FaShieldAlt,
  FaReceipt,
  FaPhoneAlt,
  FaGlobeAsia
} from "react-icons/fa";

import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";

export default function Paymentpolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* navbar sticky  */}
      <Navbarsticky/>
      
      <div className="payment-container">
      </div>

      {/* MAIN CONTENT */}
      <div className="payment-section py-5 w-100">
        <h1 className="payment-title">
          <FaMoneyBillWave className="title-icon" /> Payment Policy
        </h1>
        <Container fluid className="w-100">
          <Row className="justify-content-center">
            <Col lg={9} md={11}>
              <div className="payment-card">
                 <p className="payment-subtitle">Last Updated: On</p>
                <p>
                  At <strong>https://amh.octaloptimum.in/,</strong> we strive to make your
                  travel booking experience smooth and secure. This Payment Policy
                  outlines the terms governing all transactions conducted through
                  our website.
                </p>

                {/* 1. Accepted Payment Methods */}
                <div className="payment-block">
                  <h5>
                    <FaCreditCard className="block-icon" />
                    Accepted Payment Methods
                  </h5>

                  <p>
                    We accept the following payment methods via our secure,
                    PCI-DSS-compliant payment gateway:
                  </p>

                  <ul>
                    <li>Credit Cards (Visa, MasterCard, American Express, etc.)</li>
                    <li>Debit Cards (RuPay, Maestro, etc.)</li>
                    <li>UPI (Google Pay, PhonePe, BHIM, etc.)</li>
                    <li>Net Banking</li>
                    <li>Wallets (Paytm, etc.)</li>
                  </ul>
                </div>

                {/* 2. Payment Process */}
                <div className="payment-block">
                  <h5>
                    <FaListAlt className="block-icon" />
                    Payment Process
                  </h5>

                  <ul>
                    <li>All payments must be completed through the secure payment gateway.</li>
                    <li>Upon successful payment, you will receive a confirmation email/SMS with booking reference ID.</li>
                    <li>Instalment-based packages (if applicable) must follow the provided due dates.</li>
                  </ul>
                </div>

                {/* 3. Payment Confirmation */}
                <div className="payment-block">
                  <h5>
                    <FaGlobeAsia className="block-icon" />
                    Payment Confirmation
                  </h5>

                  <ul>
                    <li>
                      Bookings are confirmed <strong>only after full or initial payment</strong> is received.
                    </li>
                    <li>Partial payments must be cleared before deadlines to retain the booking.</li>
                  </ul>
                </div>

                {/* 4. Pricing & Currency */}
                <div className="payment-block">
                  <h5>
                    <FaMoneyBillWave className="block-icon" />
                    Pricing & Currency
                  </h5>

                  <ul>
                    <li>All prices are in INR and inclusive of applicable taxes.</li>
                    <li>Prices may change due to partner rates, currency fluctuations, or availability.</li>
                  </ul>
                </div>

                {/* 5. Transaction Fees */}
                <div className="payment-block">
                  <h5>
                    <FaReceipt className="block-icon" />
                    Transaction Fees
                  </h5>

                  <ul>
                    <li>
                      We do <strong>not charge extra convenience fees</strong> unless clearly mentioned.
                    </li>
                    <li>Your bank may apply international transaction fees (not under our control).</li>
                  </ul>
                </div>

                {/* 6. Payment Failures */}
                <div className="payment-block">
                  <h5>
                    <FaExclamationTriangle className="block-icon" />
                    Payment Failures
                  </h5>

                  <p>If your payment fails:</p>

                  <ul>
                    <li>Recheck your card/bank details and try again.</li>
                    <li>Try a different payment method.</li>
                    <li>
                      Contact support if the amount was debited but no confirmation received.
                    </li>
                  </ul>
                </div>

                {/* 7. Refunds & Cancellations */}
                <div className="payment-block">
                  <h5>
                    <FaSyncAlt className="block-icon" />
                    Refunds & Cancellations
                  </h5>

                  <ul>
                    <li>
                      Refunds follow our Cancellation & Refund Policy and return to the
                      <strong> original payment method</strong>.
                    </li>
                    <li>Refunds may take 7–14 business days depending on bank/provider.</li>
                  </ul>
                </div>

                {/* 8. Security */}
                <div className="payment-block">
                  <h5>
                    <FaShieldAlt className="block-icon" />
                    Security & Fraud Prevention
                  </h5>

                  <ul>
                    <li>SSL encryption secures all transactions.</li>
                    <li>We never store card details.</li>
                    <li>Suspicious transactions may be flagged for verification.</li>
                    <li>Fraudulent transactions may face legal action.</li>
                  </ul>
                </div>

                {/* 9. GST & Tax Invoices */}
                <div className="payment-block">
                  <h5>
                    <FaReceipt className="block-icon" />
                    GST & Tax Invoices
                  </h5>

                  <ul>
                    <li>Invoices will display GST as per government rules.</li>
                    <li>Businesses may request GST-compliant invoices.</li>
                  </ul>
                </div>

                {/* 10. Contact Support */}
                <div className="payment-block">
                  <h5>
                    <FaPhoneAlt className="block-icon" />
                    Contact for Payment Support
                  </h5>

                  <p>
                    For issues related to payment, reach out:<br />
                    Email: andamanmakeholidayss@gmail.com<br />
                    Phone: +91-8145080001
                  </p>

                  <p>Available: Monday–Saturday, 10 AM to 6 PM IST</p>
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Footer  */}
      <Footer/>
    </>
  );
}
